import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "serviceprovider",
  "use": "serviceprovider-usage",
  "viewBox": "0 0 51.3 59.2",
  "content": "<symbol viewBox=\"0 0 51.3 59.2\" id=\"serviceprovider\">\n<style type=\"text/css\">\n\t#serviceprovider .st0{fill:#FFFFFF;}\n</style>\n<g>\n\t<rect x=\"17.6\" y=\"29.7\" class=\"st0\" width=\"15.8\" height=\"26\" />\n\t<path d=\"M51.2,54.8c-1.6-8.8-7.5-16.1-15.7-19.5c-0.8-0.3-1.1-1.2-0.8-1.9c0.1-0.3,0.3-0.5,0.6-0.7c5.3-3.4,8.4-9.4,8.1-15.7\n\t\tC43,7.8,35.6,0.4,26.4,0C16.5-0.4,8.3,7.3,7.9,17.1c-0.2,6.3,2.8,12.2,8.1,15.6c0.7,0.4,0.9,1.4,0.4,2.1c-0.2,0.3-0.4,0.5-0.7,0.6\n\t\tC7.5,38.7,1.6,46.1,0.1,54.8c-0.3,2,1,3.9,3,4.3c0.2,0,0.4,0.1,0.6,0.1h43.8c2.1,0,3.7-1.7,3.7-3.7C51.3,55.3,51.3,55.1,51.2,54.8\n\t\tL51.2,54.8z M29.5,49.3l-3.4,5c-0.2,0.3-0.6,0.4-0.8,0.2c-0.1,0-0.1-0.1-0.2-0.2l-3.4-5c-0.2-0.3-0.2-0.6-0.1-1L25,37.1h-0.6\n\t\tc-0.2,0-0.4-0.1-0.4-0.3l-0.5-1.7c-0.1-0.2,0-0.4,0.2-0.5c0,0,0.1,0,0.1,0h3.6c0.2,0,0.4,0.2,0.4,0.4c0,0,0,0.1,0,0.1l-0.5,1.7\n\t\tc-0.1,0.2-0.2,0.3-0.4,0.3h-0.6l3.4,11.2C29.8,48.6,29.7,49,29.5,49.3L29.5,49.3z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/serviceprovider.svg
// module id = mCAt
// module chunks = 264